module.exports = __webpack_public_path__ + "static/media/img_game_logo_wings.058aad63.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/img_game_logo_wings.png
 ** module id = 174
 ** module chunks = 0
 **/